import script from "./AmountInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AmountInput.vue?vue&type=script&setup=true&lang=js"

import "./AmountInput.vue?vue&type=style&index=0&id=758f457e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758f457e"]])

export default __exports__